import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";
import { CalendarIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import { format } from "date-fns/format";
import React, { useEffect, useState } from "react";

interface Props {
  dueDate: string;
  onDateChange: (val: string) => void;
    onOpen: () => void;
  onClose: () => void;
}
export const CalendarButton: React.FC<Props> = ({ dueDate, onDateChange , onClose,
  onOpen,}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    dueDate ? new Date(dueDate) : null
  );
  // ✅ Sync selectedDate with dueDate prop
  useEffect(() => {
    if (dueDate?.trim()) {
      const parsed = new Date(dueDate);
      if (!isNaN(parsed.getTime())) {
        setSelectedDate(parsed);
      } else {
        setSelectedDate(null);
      }
    } else {
      setSelectedDate(null);
    }
  }, [dueDate]);

  const handleChange = (val: Date | null) => {
    if (val) {
      setSelectedDate(val);
      onDateChange?.(val.toISOString());
    }
  };
  return (
    <>
      <AdaptiveDatePicker
        trigger={
          <button className="flex items-center justify-center w-[28px] h-[28px] px-[6px] rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary hover:bg-[#ECEEF2]  hover:border-[#E9ECF2] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] min-w-max ">
            <CustomTooltip text="Set due date" position="bottom">
              <span className="flex items-center gap-1">
                <CalendarIcon />
                {selectedDate && (
                  <div className="flex items-center gap-1">
                    <span className="text-xs leading-[18px] font-medium text-secondary">
                      {format(selectedDate, "dd MMM, yyyy")}
                    </span>
                  </div>
                )}
              </span>
            </CustomTooltip>
          </button>
        }
        className="!h-[42px] border-t-0 rounded-none"
        value={selectedDate}
        onChange={(v) => {
          handleChange(v);
        }}
        onClose={onClose}
        onOpen={onOpen}
        isDisablePastDate={true}
        dateInfoIcon={
          <div className="flex items-center gap-2 pl-4 pr-2 py-2 text-secondary text-sm font-semibold uppercase border-b border-[#E9ECF2]">
            DUE DATE
          </div>
        }
      />
    </>
  );
};
